import React from 'react';
import { X, Ruler } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const MeasurementOverrideModal = ({
  isOpen,
  onClose,
  squareFootage,
  setSquareFootage,
  notes,
  setNotes,
  verified,
  setVerified,
  isProcessing,
  onSubmit
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-gray-900 flex items-center">
            <Ruler className="w-5 h-5 mr-2 text-blue-600" />
            Override Measurement
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <Label htmlFor="squareFootage">New Square Footage *</Label>
            <Input
              id="squareFootage"
              type="number"
              value={squareFootage}
              onChange={(e) => setSquareFootage(e.target.value)}
              placeholder="Enter square footage"
            />
          </div>
          
          <div>
            <Label htmlFor="notes">Notes (optional)</Label>
            <textarea
              id="notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2 min-h-[80px]"
              placeholder="Reason for override (e.g., verified on-site)"
            />
          </div>
          
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={verified}
              onChange={(e) => setVerified(e.target.checked)}
              className="rounded border-gray-300"
            />
            <span className="text-sm text-gray-700">Mark as verified measurement</span>
          </label>
          
          <p className="text-xs text-gray-500">
            Verified measurements will show a badge and won't trigger low-confidence warnings.
          </p>
        </div>

        <div className="flex gap-3 mt-6">
          <Button variant="outline" onClick={onClose} className="flex-1">
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isProcessing || !squareFootage}
            className="flex-1 bg-blue-600 hover:bg-blue-700"
          >
            {isProcessing ? 'Updating...' : 'Update Measurement'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MeasurementOverrideModal;
